/*
 * Central URL builders — the single place route strings live.
 * Content permalinks (classes/categories) resolve through the catch-all, so
 * every static path added to the router shadows a possible archive permalink.
 * Add new static routes ONLY via router.jsx's manifest, and build hrefs ONLY
 * through these helpers so a future path change is a one-file edit.
 */

export const paths = {
  home: () => "/",
  search: (q) => (q ? `/search?q=${encodeURIComponent(q)}` : "/search"),
  series: (slug) => `/series/${slug}`,
  tag: (slug) => `/tag/${slug}`,
  concept: (slug) => `/concept/${slug}`,
  // Archive permalink (class or category) — multi-segment slugs allowed.
  permalink: (slug) => `/${String(slug).replace(/^\/+/, "")}`,
  live: () => "/live",
  donations: () => "/donations",
  chaiClub: () => "/chai-club",
  askQuestion: () => "/ask-question",
  contact: () => "/contact-us",
  about: () => "/about-us",
  privacy: () => "/privacy-policy",
  signIn: () => "/sign-in",
  signUp: () => "/sign-up",
  profile: () => "/profile",
  bookmarks: () => "/user-bookmarks",
  dailyTanya: () => "/daily-tanya",
  dailyHayomYom: () => "/daily-hayom-yom",
  weeklyParsha: () => "/weekly-parsha-classes",
  monthlyClasses: () => "/monthly-classes",
  latestClasses: () => "/latest-classes",
  categories: () => "/categories",
};

/*
 * Admin lives under /admin/* (kept out of the archive-permalink namespace).
 * Old unprefixed paths remain as redirects — see LEGACY_ADMIN_REDIRECTS.
 */
export const ADMIN_BASE = "/admin";

const LEGACY_ADMIN_PATHS = [
  "/user-management",
  "/role-management",
  "/permission-management",
  "/class-management",
  "/class-management/categories",
  "/class-management/tags",
  "/class-management/tags-type",
  "/class-management/series",
  "/content-management",
  "/content-management/media-library",
  "/content-management/questions",
  "/content-management/contact-us",
  "/content-management/team",
  "/menu-management",
  "/profile-setting",
  "/page-builder",
];

export const LEGACY_ADMIN_REDIRECTS = LEGACY_ADMIN_PATHS.map((old) => ({
  from: old,
  to: `${ADMIN_BASE}${old}`,
}));
